import Box from '@mui/material/Box';
import { ReactNode } from 'react';

export default function TabLabelWithAdornment({
  endAdornment,
  label,
}: {
  endAdornment?: ReactNode;
  label: string;
}) {
  if (!endAdornment) return label;

  return (
    <Box
      component="span"
      sx={{ alignItems: 'center', display: 'inline-flex', gap: 0.75 }}
    >
      {label}
      {endAdornment}
    </Box>
  );
}
